import { IFieldServer } from "@common/redux/forms/interface";
export const urlDefaultValue: IFieldServer = {
  fieldType: "TEXT_INPUT",
  title: "Website",
  isVisible: true,
  isDisabled: false,
  isRequired: false,
  grid: {
    width: 6,
  },
  canDelete: true,
  canCopy: true,
  canAdd: true,
  type: "TEXT_INPUT",
  name: "Url",
  rules: [
    {
      rule: "URL",
      errorMessage: "Enter a Valid URL ",
    },
  ],
  fields: [],
  fieldConfig: {
    placeHolder: "Enter Url",
    isDuplicateAllowed: true,
    isPII: false,
    isQrCodeAllowed: false,
  },
};
